import { FieldArrayWithId } from 'react-hook-form';
import { FormValues } from './SpecialLeaveTab.types';

export const stringNorm = (string?: string) =>
  string?.trim().toLowerCase() ?? '';

export const buildExistingCodes = (
  rows: FieldArrayWithId<FormValues, 'special_leaves', 'specialLeavesTabKey'>[],
  editIdx: number | null,
  fteLeave?: string,
  ftePlb?: string,
  fteHolidayCompensation?: string
) =>
  [
    ...rows
      .filter((_, idx: number) => idx !== editIdx)
      .map((row) => stringNorm(row.special_leave_importCode)),
    stringNorm(fteLeave),
    stringNorm(ftePlb),
    stringNorm(fteHolidayCompensation)
    // Todo: add more fields if needed
  ].filter(Boolean);
